import React, { useEffect, useRef } from "react";
import DeviceCard from "../DeviceCard";
import Slider from "react-slick";
import { Container } from "reactstrap";
import DeviceListLoader from "./DeviceListLoader";

const DeviceListSliderView = (props) => {
    const {
        isLoading,
        deviceData,
        selectedDeviceInfo,
        onSelectDevice,
        shouldBringSelectedDeviceIntoView = false
    } = props;

    const sliderRef = useRef(null);
    const deviceBroughtIntoViewRef = useRef(null);

    const settings = {
        className: "my-device-slider",
        infinite: false,
        centerPadding: "20px",
        speed: 500,
        dots: true,
        accessibility: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        lazyLoad: true,
    };

    useEffect(() => {
        if (
            !shouldBringSelectedDeviceIntoView ||
            !selectedDeviceInfo?.deviceId ||
            !deviceData ||
            Object.keys(deviceData).length === 0
        ) {
            return;
        }

        const devices = Object.values(deviceData);

        const selectedIndex = devices.findIndex(
            (device) => device.deviceId === selectedDeviceInfo.deviceId
        );

        if (
            selectedIndex !== -1 &&
            deviceBroughtIntoViewRef.current !== selectedDeviceInfo.deviceId
        ) {
            sliderRef.current?.slickGoTo(selectedIndex);

            deviceBroughtIntoViewRef.current =
                selectedDeviceInfo.deviceId;
        }
    }, [
        selectedDeviceInfo,
        deviceData,
        shouldBringSelectedDeviceIntoView
    ]);

    return (
        <div className="my-devices-list-carousel-view">
            <Container>
                <Slider ref={sliderRef} {...settings}>
                    {
                        (isLoading)
                        ? (
                            [...Array(5)].map((_, index) => (
                                <DeviceListLoader cname="slider-card-loader"/>
                            ))
                        )
                        : (
                            Object.keys(deviceData).length > 0 
                            &&  Object.values(deviceData).map((device, index) => (
                                <DeviceCard
                                    cname="slider-card"
                                    key={index}
                                    device={device}
                                    index={index}
                                    selectedDevice={selectedDeviceInfo}
                                    onClick={onSelectDevice}
                                />
                            ))
                        )
                    }
                </Slider>
            </Container>
        </div>
    )
}

export default DeviceListSliderView;